import { render } from "./SetPasswordSuperAdmin.vue?vue&type=template&id=4edde66e&scoped=true"
import script from "./SetPasswordSuperAdmin.vue?vue&type=script&lang=js"
export * from "./SetPasswordSuperAdmin.vue?vue&type=script&lang=js"

import "./SetPasswordSuperAdmin.vue?vue&type=style&index=0&id=4edde66e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4edde66e"]])

export default __exports__